<script>
    /**
 *
 *
 *
 *
 */

    /*                */
    let { filters = [], removeFilterCallBack, noRecommendationsFoundWithSellerFilters = false } = $props();
</script>

<div class="reco_cinema_filters">
    {#if !noRecommendationsFoundWithSellerFilters}
        {#if filters}
            {#each filters as filter}
                <oc-chip-v1
                    removable
                    inverted
                    onoc-remove={() => {
                        removeFilterCallBack(filter);
                    }}
                >
                    {filter.name}
                </oc-chip-v1>
            {/each}
        {/if}
    {:else}
        <oc-banner-v1 variant="warning" hideCloseButton>
            0 Artikel die deiner Filterung entsprechen. Zeige passende Artikel ohne Filterung an
        </oc-banner-v1>
    {/if}
</div>

<style lang="scss">
    .reco_cinema_filters {
        padding-bottom: 16px;
        margin-left: 16px;
    }
</style>
